import { QUANTUM } from 'core/constants/products'
import isPlanType from 'utils/pivot/plan/isPlanType'

function isQuantumPlan(plan: Plan): boolean {
  return isPlanType(plan, QUANTUM)
}

export default isQuantumPlan
